"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const moment = require("moment");
const LogManager_1 = require("../../Log/LogManager");
const DomainRxEventHandler_1 = require("../../Engine/Event/DomainRxEventHandler");
const FudaoDefinition_1 = require("../FudaoDefinition");
const FudaoUser_1 = require("../FudaoUser");
const FudaoEvent_1 = require("../FudaoEvent");
const FudaoDto_1 = require("../Protocol/FudaoDto");
class FudaoEventToChatAdapter {
    constructor(cas, scas, fcas, evtHub) {
        this._logger = LogManager_1.logManager.GetLogger("FudaoEventToChatAdapter");
        this._curFudaoUser = FudaoUser_1.FudaoUser.INVALID_FUDAO_USER;
        this._chatAppService = cas;
        this._sessionAppService = scas;
        this._fudalAppService = fcas;
        this._evtHub = evtHub;
        this._eventHandler = new DomainRxEventHandler_1.DomainRxEventHandler(FudaoEvent_1.FudaoEvent.Category, this._logger, this._evtHub);
        //處理開始輔導Event
        this._eventHandler.registerAsyncEventHandler(FudaoEvent_1.FudaoEvent.TeacherStartInvitationCanceled, async (evt) => await this.OnTeacherStartInvitationCanceledAsync(evt));
        this._eventHandler.registerAsyncEventHandler(FudaoEvent_1.FudaoEvent.StudentStartInvitationRejected, async (evt) => await this.OnStudentStartInvitationRejectedAsync(evt));
        this._eventHandler.registerAsyncEventHandler(FudaoEvent_1.FudaoEvent.StudentStartInvitationNoResponse, async (evt) => await this.OnStudentStartInvitationNoResponseAsync(evt));
        this._eventHandler.registerAsyncEventHandler(FudaoEvent_1.FudaoEvent.FudaoStarted, async (evt) => await this.OnFudaoStartedAsync(evt));
        //處理延長輔導Event
        this._eventHandler.registerAsyncEventHandler(FudaoEvent_1.FudaoEvent.TeacherExtendInvitationCanceled, async (evt) => await this.OnTeacherExtendInvitationCanceled(evt));
        this._eventHandler.registerAsyncEventHandler(FudaoEvent_1.FudaoEvent.StudentExtendInvitationRejected, async (evt) => await this.OnTeacherExtendInvitationRejected(evt));
        this._eventHandler.registerAsyncEventHandler(FudaoEvent_1.FudaoEvent.StudentExtendInvitationNoReponse, async (evt) => await this.OnTeacherExtendInvitationNoResponse(evt));
        this._eventHandler.registerAsyncEventHandler(FudaoEvent_1.FudaoEvent.FudaoExtended, async (evt) => await this.OnFudaoExtendedAsync(evt));
        //處理結束輔導Event
        this._eventHandler.registerAsyncEventHandler(FudaoEvent_1.FudaoEvent.TeacherEndInvitationCanceled, async (evt) => await this.OnTeacherEndInvitationCanceled(evt));
        this._eventHandler.registerAsyncEventHandler(FudaoEvent_1.FudaoEvent.StudentEndInvitationRejected, async (evt) => await this.OnTeacherEndInvitationRejected(evt));
        this._eventHandler.registerAsyncEventHandler(FudaoEvent_1.FudaoEvent.StudentEndInvitationNoResponse, async (evt) => await this.OnTeacherEndInvitationNoResponse(evt));
        this._eventHandler.registerAsyncEventHandler(FudaoEvent_1.FudaoEvent.FudaoEnded, async (evt) => await this.OnFudaoEndedAsync(evt));
        //處理開始FudaoSessionEvent
        this._eventHandler.registerAsyncEventHandler(FudaoEvent_1.FudaoEvent.TeacherStartSessionInvitationCanceled, async (evt) => await this.OnFudaoSessionEvent(evt));
        this._eventHandler.registerAsyncEventHandler(FudaoEvent_1.FudaoEvent.StudentStartSessionInvitationRejected, async (evt) => await this.OnFudaoSessionEvent(evt));
        this._eventHandler.registerAsyncEventHandler(FudaoEvent_1.FudaoEvent.StudentStartSessionInvitationNoReponse, async (evt) => await this.OnFudaoSessionEvent(evt));
        //處理結束FudaoSessionEvent
        this._eventHandler.registerAsyncEventHandler(FudaoEvent_1.FudaoEvent.TeacherEndSessionInvitationCanceled, async (evt) => await this.OnFudaoSessionEvent(evt));
        this._eventHandler.registerAsyncEventHandler(FudaoEvent_1.FudaoEvent.StudentEndSessionInvitationRejected, async (evt) => await this.OnFudaoSessionEvent(evt));
        this._eventHandler.registerAsyncEventHandler(FudaoEvent_1.FudaoEvent.StudentEndSessionInvitationNoReponse, async (evt) => await this.OnFudaoSessionEvent(evt));
        this._eventHandler.registerAsyncEventHandler(FudaoEvent_1.FudaoEvent.FudaoSessionEnded, async (evt) => await this.OnFudaoSessionEvent(evt));
    }
    async initAsync(localFudaoUser) {
        //User轉成FudaoUser
        this._curFudaoUser = localFudaoUser;
    }
    async terminateAsync() {
    }
    async OnTeacherStartInvitationCanceledAsync(evt) {
        await this.TeacherSendChatMessage(evt, "取消輔導");
    }
    async OnStudentStartInvitationRejectedAsync(evt) {
        await this.StudentSendChatMessage(evt, "拒絕輔導");
    }
    async OnStudentStartInvitationNoResponseAsync(evt) {
        await this.StudentSendChatMessage(evt, "無回應");
    }
    async OnFudaoStartedAsync(evt) {
        await this.TeacherSendChatMessage(evt, "輔導開始");
    }
    async OnTeacherExtendInvitationCanceled(evt) {
        await this.TeacherSendChatMessage(evt, "取消延長課時");
    }
    async OnTeacherExtendInvitationRejected(evt) {
        await this.StudentSendChatMessage(evt, "拒絕延長課時");
    }
    async OnTeacherExtendInvitationNoResponse(evt) {
        await this.StudentSendChatMessage(evt, "無回應");
    }
    async OnFudaoExtendedAsync(evt) {
        await this.TeacherSendChatMessage(evt, "輔導課時已延長");
    }
    async OnTeacherEndInvitationCanceled(evt) {
        await this.TeacherSendChatMessage(evt, "取消結束輔導");
    }
    async OnTeacherEndInvitationRejected(evt) {
        await this.StudentSendChatMessage(evt, "拒絕結束輔導");
    }
    async OnTeacherEndInvitationNoResponse(evt) {
        await this.StudentSendChatMessage(evt, "無回應");
    }
    async OnFudaoEndedAsync(evt) {
        const fudaoId = evt.entityId;
        const fudaoDto = await this._fudalAppService.fudaoOfIdAsync(fudaoId);
        const fudaoDuration = moment.utc(fudaoDto.duration());
        const fudaoStatus = fudaoDto.status;
        const summary = `輔導時間總長${fudaoDuration.format("HH:mm:ss")}`;
        switch (fudaoStatus) {
            case FudaoDefinition_1.Status.Ended:
                if (this._curFudaoUser.Is(fudaoDto.teacher)) {
                    //正常結束只有老師需發輔導訊息
                    await this.TeacherSendChatMessage(evt, summary);
                }
                break;
            case FudaoDefinition_1.Status.AbnormalEnded:
                if (this._curFudaoUser.Is(fudaoDto.teacher)) {
                    //輔導裡的老師才需發此訊息
                    const msg = `輔導不正常結束, ${summary}, 請記錄輔導Id=${fudaoId}, 聯絡客服人員`;
                    await this.TeacherSendChatMessage(evt, msg);
                }
                break;
            case FudaoDefinition_1.Status.Interrupted:
                if (this._curFudaoUser.Is(fudaoDto.teacher)) {
                    const msgTeacher = `老師端偵測到輔導已中斷, ${summary}, Id=${fudaoId}`;
                    await this.TeacherSendChatMessage(evt, msgTeacher);
                }
                else if (this._curFudaoUser.Is(fudaoDto.student)) {
                    const msgStudent = `學生端偵測到輔導已中斷, ${summary}, Id=${fudaoId}`;
                    await this.StudentSendChatMessage(evt, msgStudent);
                }
                break;
        }
    }
    async TeacherSendChatMessage(evt, msg) {
        const fudaoDto = new FudaoDto_1.FudaoDto(evt.bodyTo());
        if (!this._curFudaoUser.Is(fudaoDto.teacher))
            return;
        if (!fudaoDto.chatId)
            throw Error(`FudaoDto.chatId should not be empty.`);
        const cmDto = await this._chatAppService.newTextChatMessageAsync(fudaoDto.chatId, this._curFudaoUser.Name, msg);
        await this._chatAppService.speakToChatAsync(cmDto);
    }
    async StudentSendChatMessage(evt, msg) {
        const fudaoDto = new FudaoDto_1.FudaoDto(evt.bodyTo());
        if (!this._curFudaoUser.Is(fudaoDto.student))
            return;
        if (!fudaoDto.chatId)
            throw Error(`FudaoDto.chatId should not be empty.`);
        const cmDto = await this._chatAppService.newTextChatMessageAsync(fudaoDto.chatId, this._curFudaoUser.Name, msg);
        await this._chatAppService.speakToChatAsync(cmDto);
    }
    async OnFudaoSessionEvent(evt) {
        const fudaoId = evt.entityId;
        const fudaoDto = await this._fudalAppService.fudaoOfIdAsync(fudaoId);
        if (fudaoDto === FudaoDto_1.FudaoDto.INVALID_FUDAO_DTO) {
            this._logger.warn(`Invalid FudaoDto`);
            return;
        }
        const fudaoSession = new FudaoDefinition_1.FudaoSession(evt.bodyTo());
        switch (evt.name) {
            case FudaoEvent_1.FudaoEvent.TeacherStartSessionInvitationCanceled:
                {
                    const msg = `取消${FudaoEventToChatAdapter.FudaoSessionTypeToMsg(fudaoSession.SessionType)}`;
                    await this.TeacherSendFudaoSessionRelatedChatMessage(fudaoDto, msg);
                }
                break;
            case FudaoEvent_1.FudaoEvent.StudentStartSessionInvitationRejected:
                {
                    const msg = `學生拒絕${FudaoEventToChatAdapter.FudaoSessionTypeToMsg(fudaoSession.SessionType)}邀請`;
                    await this.StudentSendFudaoSessionRelatedChatMessage(fudaoDto, msg);
                }
                break;
            case FudaoEvent_1.FudaoEvent.StudentStartSessionInvitationNoReponse:
                {
                    const msg = `學生無回應`;
                    await this.StudentSendFudaoSessionRelatedChatMessage(fudaoDto, msg);
                }
                break;
            case FudaoEvent_1.FudaoEvent.TeacherEndSessionInvitationCanceled:
                {
                    const msg = `取消結束${FudaoEventToChatAdapter.FudaoSessionTypeToMsg(fudaoSession.SessionType)}`;
                    await this.TeacherSendFudaoSessionRelatedChatMessage(fudaoDto, msg);
                }
                break;
            case FudaoEvent_1.FudaoEvent.StudentEndSessionInvitationRejected:
                {
                    const msg = `學生拒絕結束${FudaoEventToChatAdapter.FudaoSessionTypeToMsg(fudaoSession.SessionType)}邀請`;
                    await this.StudentSendFudaoSessionRelatedChatMessage(fudaoDto, msg);
                }
                break;
            case FudaoEvent_1.FudaoEvent.StudentEndSessionInvitationNoReponse:
                {
                    const msg = `學生無回應`;
                    await this.StudentSendFudaoSessionRelatedChatMessage(fudaoDto, msg);
                }
                break;
            case FudaoEvent_1.FudaoEvent.FudaoSessionEnded:
                {
                    const sessionType = FudaoEventToChatAdapter.FudaoSessionTypeToMsg(fudaoSession.SessionType);
                    const durationTs = this._sessionAppService.querySessionDuration(fudaoSession.Id);
                    const durationFormatedTime = moment.utc(durationTs.asMilliseconds()).format("HH:mm:ss");
                    const msg = `${sessionType}時間總長${durationFormatedTime}`;
                    await this.TeacherSendFudaoSessionRelatedChatMessage(fudaoDto, msg);
                }
                break;
        }
    }
    async TeacherSendFudaoSessionRelatedChatMessage(fudaoDto, msg) {
        if (!this._curFudaoUser.Is(fudaoDto.teacher))
            return;
        if (!fudaoDto.chatId)
            throw Error(`FudaoDto.chatId should not be empty.`);
        const cmDto = await this._chatAppService.newTextChatMessageAsync(fudaoDto.chatId, this._curFudaoUser.Name, msg);
        await this._chatAppService.speakToChatAsync(cmDto);
    }
    async StudentSendFudaoSessionRelatedChatMessage(fudaoDto, msg) {
        if (!this._curFudaoUser.Is(fudaoDto.student))
            return;
        if (!fudaoDto.chatId)
            throw Error(`FudaoDto.chatId should not be empty.`);
        const cmDto = await this._chatAppService.newTextChatMessageAsync(fudaoDto.chatId, this._curFudaoUser.Name, msg);
        await this._chatAppService.speakToChatAsync(cmDto);
    }
    static FudaoSessionTypeToMsg(fst) {
        switch (fst) {
            case FudaoDefinition_1.FudaoSessionType.TeacherVideo:
                return "視訊";
            case FudaoDefinition_1.FudaoSessionType.Audio:
                return "通話";
            case FudaoDefinition_1.FudaoSessionType.Whiteboard:
                return "白板";
            default:
                return "";
        }
    }
}
exports.FudaoEventToChatAdapter = FudaoEventToChatAdapter;
//# sourceMappingURL=FudaoEventToChatAdapter.js.map